document.addEventListener('DOMContentLoaded', function () {
  var button = document.getElementById('LoadMoreButton');
  if (!button) return;

  button.addEventListener('click', function () {
    var nextUrl = button.getAttribute('data-next-url');
    if (!nextUrl) return;

    var spinner = document.getElementById('LoadMoreSpinner');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (spinner) spinner.hidden = false;

    fetch(nextUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var currentGrid = document.getElementById('product-grid');
        var newItems = doc.querySelectorAll('#product-grid .grid__item');

        newItems.forEach(function (item) {
          currentGrid.appendChild(item);
        });

        var newButton = doc.getElementById('LoadMoreButton');
        if (newButton) {
          var newNextUrl = newButton.getAttribute('data-next-url');
          if (newNextUrl) {
            button.setAttribute('data-next-url', newNextUrl);
          } else {
            button.remove();
          }
        } else {
          button.remove();
        }
      })
      .catch(function () {
        // Leave the button in place so the customer can retry.
      })
      .finally(function () {
        if (document.body.contains(button)) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        if (spinner) spinner.hidden = true;
      });
  });
});
